"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _constants = require("../constants");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var HeaderTitle = _styledComponents["default"].h1.attrs(function () {
  return _objectSpread({}, (0, _oxygenConfig.getTestAttributes)('MODAL_HEADER_TITLE'));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  text-align: ", ";\n  ", "\n  ", ";\n  margin: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.headerFontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.headerTitleFontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.headerTitleLineHeight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.headerTitleFontWeight;
}, function (_ref5) {
  var alignTitle = _ref5.alignTitle;
  return alignTitle;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.headerTitleFontLetterSpacing && "letter-spacing: ".concat(theme.headerTitleFontLetterSpacing, ";");
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.headerTitleWrap && (0, _polished.ellipsis)();
});
HeaderTitle.propTypes = {
  alignTitle: _propTypes["default"].oneOf(Object.values(_constants.MODAL_HEADER_ALIGN_TITLE))
};
HeaderTitle.defaultProps = {
  alignTitle: _constants.MODAL_HEADER_ALIGN_TITLE.LEFT
};
var _default = HeaderTitle;
exports["default"] = _default;